import { ModuleContainer } from '../../layout/ModuleContainer.tsx';
import { OrderDetailsModule } from '../../modules/orderDetails/OrderDetailsModule.tsx';

export const OrderDetailsRouteElement = () => (
  <ModuleContainer moduleID="details" compact>
    <OrderDetailsModule />
  </ModuleContainer>
);
